import React from 'react'
import styled from 'styled-components'
import { useDevice } from '../../../hook/useDevice'
import { Text, View } from '../../../styles'
import { MENU_LIST } from '../../../mock'
import { devices } from '../../../utils/responsive'

const Nav: React.FC<any> = () => {
  const { isDesktop, isMobile } = useDevice()
  return (
    <StyledNavigator mobile={isDesktop ? false : true}>
      <StyledNavigatorItem href='#mverse' className='active'>
        <Text size='md'>About</Text>
      </StyledNavigatorItem>
      <StyledNavigatorItem href='#overview'>
        <Text size='md'>Overview</Text>
      </StyledNavigatorItem>
      <StyledNavigatorItem href='#ecosystem'>
        <Text size='md'>Ecosystem</Text>
      </StyledNavigatorItem>
      <StyledNavigatorItem href='#service'>
        <Text size='md'>Service</Text>
      </StyledNavigatorItem>
      <StyledNavigatorItem href='#download'>
        <Text size='md'>Download</Text>
      </StyledNavigatorItem>
      <StyledNavigatorItem href='#team'>
        <Text size='md'>Team</Text>
      </StyledNavigatorItem>
      <StyledNavigatorItem href='#contact'>
        <Text size='md'>Contact us</Text>
      </StyledNavigatorItem>
    </StyledNavigator>
  )
}

export default Nav

const StyledNavigator = styled.div<{ mobile?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 7%;
  width: 100%;
  max-width: 1024px;
  background-color: transparent;

  @media ${devices.desktopSmall} {
    gap: 3%;
  }
`

const StyledNavigatorItem = styled.a`
  color: var(--gray-color-200);

  .active,
  &:hover {
    color: var(--black-color);
  }
`
